import { render } from "./ExpedientDetailUploadFilesModal.vue?vue&type=template&id=69f2a2c2"
import script from "./ExpedientDetailUploadFilesModal.vue?vue&type=script&lang=js"
export * from "./ExpedientDetailUploadFilesModal.vue?vue&type=script&lang=js"

import exportComponent from "/data/api/peitho-pre.uniqoderslab.com/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__